export const config = {
    subPath: '/',
    // apiHostGw: 'https://api-gateway.sampangkab.go.id/be-ppid',
    apiHostGw: 'https://api-gw2.sampangkab.go.id/ppid'
    // apiHostGw: 'http://10.200.1.27:9031'
    // apiHostGw: 'http://ppid-app.test'
}